import * as React from "react"
import { cn } from "@/lib/utils/cn"

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[120px] w-full rounded-xl border border-slate-200 bg-white px-4 py-3",
          "text-base text-slate-900 placeholder:text-slate-400",
          "transition-all duration-200 ease-out",
          "hover:border-slate-300",
          "focus:border-primary/50 focus:ring-2 focus:ring-primary/10 focus:outline-none",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-slate-50",
          "resize-y",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
